<template>
  <div class="mb-5" style="background-color: #f8f8f8; padding: 20px">
    <h4 class="h5 fw-bold mb-3">
      {{
        $t(
          `project.previewAndReport.reportTypes.${reportType}.servicesOffered.title`
        )
      }}
    </h4>
    <div class="row">
      <div class="col-12">
        <p class="mb-1">
          {{
            $t(
              `project.previewAndReport.reportTypes.${reportType}.servicesOffered.description`
            )
          }}
        </p>
        <p>
          {{
            $t(
              `project.previewAndReport.reportTypes.${reportType}.servicesOffered.additionalServices`
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ServicesSection",
  props: {
    reportType: {
      type: String,
      required: true,
    },
  },
});
</script>
